import React from 'react';
import { ASSETS } from '../../assetManifest.js';
import { CONSTANTS } from '../../data.js';
import { canBreedDragons } from '../../gameLogic/breedingLogic.js';
import { getRarityColor, getElementColor, getElementGlow } from '../../utils/gameUtils.js';
import { getAssetKey } from '../../utils/assetUtils.js';

const BreedingTab = ({ 
  playerDragons, 
  selectedBreedingDragons, 
  onBreedingSelection, 
  onBreed 
}) => {
  const canBreed = canBreedDragons(selectedBreedingDragons, playerDragons);

  return (
    <div className="card-enhanced h-full flex flex-col">
      <div className="flex items-center space-x-3 mb-4 flex-shrink-0">
        <h2 className="text-2xl font-mono font-semibold text-purple-400 text-glow">Breeding Altar</h2>
      </div>
      
      <div className="flex flex-col lg:flex-row gap-4 flex-1 min-h-0">
        <div className="lg:w-1/3 flex-shrink-0 bg-black/20 p-4 rounded-lg border border-white/10">
          <p className="text-sm text-gray-300 mb-3 font-sans">Select 2 dragons to combine:</p>
          <div className="flex flex-col gap-2 mb-4 min-h-[104px]">
            {selectedBreedingDragons.map((dragonId) => {
              const dragon = playerDragons.find(d => d.id === dragonId);
              return dragon ? (
                <div key={dragonId} className="flex items-center bg-gray-700/50 rounded-lg p-2 border-l-4" style={{borderColor: getElementColor(CONSTANTS.DRAGONS[dragon.name].element)}}>
                  <img
                    src={ASSETS.dragons[getAssetKey(dragon.name)].path}
                    alt={dragon.name}
                    className="w-8 h-8 mr-3"
                  />
                  <span className="text-sm font-semibold font-sans">{dragon.name} Lvl. {dragon.level}</span>
                </div>
              ) : null;
            })}
          </div>
          
          <button
            onClick={onBreed}
            disabled={!canBreed}
            className="btn btn-secondary w-full text-lg py-3 font-mono"
          >
            Combine
          </button>
        </div>

        <div className="flex-1 min-h-0">
          <div className="text-lg font-mono text-gray-300 mb-3">Your Dragons:</div>
          <div className="h-full overflow-y-auto custom-scrollbar pr-2 -mr-2">
            {playerDragons.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {playerDragons.map(dragon => {
                  const dragonData = CONSTANTS.DRAGONS[dragon.name];
                  const isSelected = selectedBreedingDragons.includes(dragon.id);

                  return (
                    <div
                      key={dragon.id}
                      className={`bg-gray-900/50 p-3 rounded-lg cursor-pointer transition-all duration-300 border border-transparent relative overflow-hidden ${
                        isSelected ? 'border-purple-400 bg-purple-900/30' : 'hover:border-white/20 hover:bg-gray-900/80'
                      }`}
                      style={{ '--element-color': getElementColor(dragonData.element) }}
                      onClick={() => onBreedingSelection(dragon.id)}
                    >
                      <div className="absolute top-0 left-0 w-full h-1 bg-[var(--element-color)] opacity-50"></div>
                      <div className="flex items-center">
                        <div className="relative mr-3">
                          <img
                            src={ASSETS.dragons[getAssetKey(dragon.name)].path}
                            alt={dragon.name}
                            className="w-12 h-12"
                            style={{ filter: `drop-shadow(0 0 4px ${getElementGlow(dragonData.element)})` }}
                          />
                          <div className="absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-black"
                              style={{ backgroundColor: getRarityColor(dragonData.rarity) }}>
                            {dragon.level}
                          </div>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-mono font-bold">{dragon.name}</p>
                          <p className="text-xs font-sans" style={{ color: getRarityColor(dragonData.rarity) }}>
                            {dragonData.rarity}
                          </p>
                        </div>
                        {isSelected && (
                          <div className="w-5 h-5 bg-purple-500 rounded-full flex items-center justify-center ring-2 ring-black">
                            <div className="w-2 h-2 bg-white rounded-full"></div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center text-gray-400 text-lg py-8 opacity-50">
                <p className="text-4xl mb-4">🐉</p>
                <p className="font-mono">No dragons available for breeding</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreedingTab;
